<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 0.714844C12.4183 0.714845 16 4.29657 16 8.71484C16 13.1331 12.4183 16.7148 8 16.7148C3.58172 16.7148 7.73132e-07 13.1331 0 8.71484C0 4.29657 3.58172 0.714844 8 0.714844ZM7.39941 5.21289V8.96094L10.5752 12.1367L11.4229 11.2891L8.59863 8.46484V5.21289H7.39941Z" fill="white"/>
</svg>
